import {useEffect, useState} from "react";

export enum ColourScheme {
    light = "theme-light",
    dark = "theme-dark",
}

export interface ColourSchemeHook {
    colourScheme?: ColourScheme;
    setColourScheme: (colourScheme: ColourScheme) => void;
}

const useColourScheme = (): ColourSchemeHook => {

    const [colourScheme, setCs] = useState<ColourScheme>();

    useEffect(() => {
        // Add listener to update styles
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
            setColourScheme(e.matches ? ColourScheme.dark : ColourScheme.light)
        });

        let lsColour = localStorage.getItem('colourScheme')
        if (!!lsColour && (Object.values(ColourScheme) as string[]).includes(lsColour)) {
            let cs = lsColour as ColourScheme;
            setColourScheme(cs)
            return;
        }

        // Setup dark/light mode for the first time
        setColourScheme(window.matchMedia('(prefers-color-scheme: dark)').matches ? ColourScheme.dark : ColourScheme.light)

        // Remove listener
        return () => {
            window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', () => {
            });
        }
    }, []);

    useEffect(() => {
        if (!colourScheme) {
            return;
        }

        const body = document.getElementsByTagName('body')[0]
        body.className = colourScheme;
    }, [colourScheme])

    const setColourScheme = (colourScheme: ColourScheme): void => {
        setCs(colourScheme);
        localStorage.setItem('colourScheme', colourScheme);
    }

    return {
        colourScheme,
        setColourScheme
    }
}

export default useColourScheme;